


export default function Modal(props: React.PropsWithChildren) {
  return <div className="absolute left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50">
    <div className="w-full h-full flex flex-col items-center justify-center">
      {props.children}
    </div>
  </div>
}